import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import IconWatchChurch from '../../../assets/images/watch-church.svg';
import DinnerParty from '../../../assets/images/DinnerParty.svg';
import Inbox from '../../../assets/images/InboxService.svg';
import {
  AuthContainer,
  NavigationButton,
  HeaderContainer,
  WatchChurchButton,
} from './index.styled';
import Link from 'next/link';
import { TABS } from '../../../constans/profileNavigation';
import LeaderTools from '../../../assets/images/leader-tools.svg';
import LeaderToolsActive from '../../../assets/images/leader-tools-active.svg';
import HomeFeed from '../../../assets/images/dashboard-no-color.svg';
import DashboardColor from '../../../assets/images/dashboard-icon.svg';
import { modals } from '../../../constans/modals';

export const MobileMenu = ({
  icon,
  activeService,
  tabs,
  children,
  handleModalOpen,
  divRef=null
}) => {
  const { userData } = useSelector((state) => state.user);
  const [isSafari, setIsSafari] = useState(0);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (/Version\/(\S+).*?Safari\//.test(navigator.userAgent)) {
        setIsSafari(1);
      }
    }
  }, []);

  return (
    <HeaderContainer ref={divRef}>
      <AuthContainer isSafari={isSafari}>
        <Link href={'/home'}>
          <NavigationButton isCurrent={tabs === TABS.HOMEFEED}>
            {tabs === TABS.HOMEFEED ? <DashboardColor /> : <HomeFeed />}
          </NavigationButton>
        </Link>

        <Link href={'/groups'}>
          <NavigationButton isCurrent={tabs === TABS.DINNER_PARTY}>
            <DinnerParty />
          </NavigationButton>
        </Link>
        <Link href={'/inbox'}>
          <NavigationButton isCurrent={tabs === TABS.INBOX}>
            <Inbox />
          </NavigationButton>
        </Link>
        {userData.is_leader && (
          <NavigationButton
            isCurrent={tabs === TABS.LEADER_TOOLS}
            onClick={() => handleModalOpen(modals.LEADER_TOOLS)}
          >
            {tabs === TABS.LEADER_TOOLS ? (
              <LeaderToolsActive />
            ) : (
              <LeaderTools />
            )}
          </NavigationButton>
        )}
        {/* {activeService && tabs === TABS.DINNER_PARTY && (
          <Link href={'service'}>
            <WatchChurchButton>
              <IconWatchChurch />
              Watch Church
            </WatchChurchButton>
          </Link>
        )} */}
      </AuthContainer>
      {children}
    </HeaderContainer>
  );
};
